<template>
    <a-config-provider
		:locale="zhCN"
		:transformCellText="transformCellTextFun">
        <router-view />
    </a-config-provider>
</template>
<script>
import { reactive, toRefs, onBeforeMount, onMounted } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
export default {
    name: "App",
    setup() {
		// 表格单元格空格默认展示 '--'
        const transformCellTextFun = ({ text, column, record, index }) => {
            return text.length !== 0 ? text : "--";
        };
        return {
            zhCN,
            transformCellTextFun,
        };
    },
};
</script>
<style lang="less"></style>
